<div fxLayout="column" [ngStyle]="{'max-height.px': innerHeight}" class="layout-padd">



    <div id="title" fxLayout="column" fxLayoutGap="10px" class="text-center">

        <div fxLayout="row">
            <div class="text-center" fxFlex>
                {{(suggestionFormules.length>1?'formules.prod_title_menus':'formules.prod_title_menu')|translate:{'prod':prodselected.display_lang.name}
                }}</div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxFlex class="mat-title boldest">
            <div>
                {{(suggestionFormules.length>1?'formules.suggestionsFormulesTitle':'formules.suggestionFormulesTitle')|translate}}
            </div>
        </div>

    </div>


    <div fxLayout="column" class="layout-padd scrolled " fxLayoutGap="20px"
        style="margin-bottom: 70px; padding-top: 10px;" id="#popupCont" [ngStyle]="{'height.px': height}">

        <div *ngIf="pointOfsale && !pointOfsale.webshop_display_mode || media.isActive('xs')  " class="full-w"
          >

            <div fxLayout="row wrap" fxLayoutGap="0" fxLayout.xs="column" fxLayoutGap.xs="10px">

                <div *ngFor="let prod of suggestionFormules ; let first = first;let index = index;"
                    fxFlex="{{suggestionFormules.length>1?50:100}}" fxFlex.xs=100 id="id_{{index}}">


                    <div *ngIf="index<maxlengthFormule" class="clicked card-padd" fxLayout="row" ngClass.xs="card-padd-xs"
                        style="position: relative;" [class.borderGreen]="prod.productSuggeAdded" angulartics2On="click"
                        (click)="openProdDial(prod)" angularticsAction="openProductDialog"
                        angularticsCategory="products">

                        <!-- Out of stock badge -->
                        <div class="out-of-stock-badge-grid text-align" fxLayoutAlign="center center"
                            *ngIf="prod.stock && prod.stock.count <= 0">
                            <span class="boldest mat-caption">{{"unavailable"|translate}} </span>
                        </div>

                        <!-- type menu Badge -->

                        <div *ngIf="prod.product_type==2 && (!prod.stock ||prod.stock && prod.stock.count > 0)"
                            fxLayoutAlign="center center" class="text-align menu  menu-badge-card-grid "
                            ngClass.xs="menu-badge-card-pos-list-xs">
                            <span class="mat-caption boldest">{{'Menu'|translate}}</span>
                        </div>
                        <!-- type option Badge -->
                        <!-- <div *ngIf="prod.product_type==1 && (!prod.stock ||prod.stock && prod.stock.count > 0)"
                            fxLayoutAlign="center center" class="text-align option  menu-badge-card-grid "
                            ngClass.xs="menu-badge-card-pos-list-xs">
                            <span class="mat-caption boldest">{{'Option'|translate}}</span>
                        </div> -->
                         <!-- type new Badge -->
                         <div *ngIf="ProductService.getNewProduct(prod.date)" fxLayoutAlign="center center"
                         class="text-align new  new-badge-card-grid "
                         ngClass.xs="new-badge-card-pos-list-xs-formule" [class.zindex-1]="prod.stock && prod.stock.count <= 0">
                         <span class="mat-caption boldest">{{'New'|translate}}</span>
                     </div>

                        <!-- Price period Badge -->
                        <div *ngIf="prod.id_price_period > 0" class="layout-padd-1 secondary clicked promo-badge-grid"
                            angulartics2On="click" angularticsAction="openPromoShedulesDial"
                            angularticsCategory="product">
                            <span class="mat-caption boldest">{{ProductService.getPricePeriodName(prod.id_price_period) | capitalize}}</span>
                        </div>

                        <div fxLayout="row" class="rad-bord"
                            [class.out-of-stock-prod]="prod.stock && prod.stock.count <= 0"
                            style="padding: 10px; background: white; border: 1px solid #ddd;overflow: hidden;" fxFlex>

                            <div fxLayout="column" fxFlex class="hidden-overflow">

                                <!-- Nom -->
                                <div style="padding-bottom: 5px;" fxLayout="row" fxFlex>

                                    <div class="list-title elipis">{{prod.display_lang.name}}</div>
                                </div>


                                <div class="truncate-text-2" *ngIf="prod.description">
                                    <p class="list-desc desc-color">{{prod.display_lang.description |
                                        removeHtmlFromString
                                        }}</p>
                                </div>

                                <!-- Comble le vide -->
                                <div fxFlex></div>

                                <!-- Prix -->


                                <div style="padding-top: 5px;" *ngIf="prod.prices[0].price> 0">

                                    <span class="list-price" ><span *ngIf="prodselected.prices[0].price <= prod.prices[0].price+price_supp">+</span> {{ getPrice(prod) |discountVipFilter:merchantClient$:prod
                                        |
                                        priceFilter}}</span>

                                   <!-- <span class="list-price">+ {{ (prod.prices[0].price-prodselected.prices[0].price)
                                        |discountVipFilter:merchantClient$:prod
                                        |
                                        priceFilter}}</span> -->


                                </div>


                            </div>


                            <!-- Images -->
                            <img *ngIf="prod.image.length > 0" src="{{prod.image[1]}}" class="prod-img rad-bord"
                                ngClass.xs="prod-img-xs">
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <!-- List Type -->
        <div *ngIf="pointOfsale && pointOfsale.webshop_display_mode && !media.isActive('xs')" class="full-w"
            id="#popupCont" >




            <div fxLayout="row wrap">



                <div *ngFor="let prod of suggestionFormules; let first = first; let index =index;" fxFlex="33"
                    fxFlex.xl=25 fxFlex.xs=100 id="id_{{index}}">
                    <div *ngIf="index<maxlengthFormule" class="clicked" style="height: 300px; position: relative; padding: 10px;"
                        (click)="openProdDial(prod)" angulartics2On="click" angularticsAction="openProductDialog"
                        angularticsCategory="products">


                        <div fxLayout="column" fxLayoutGap="5px" class="rad-bord whited"
                            style="border: 1px solid #ddd;  position: relative;overflow: hidden;"
                            [class.borderGreen]="prod.productSuggeAdded" fxFlex>
                            <!-- Out of stock badge -->
                            <div class="out-of-stock-badge-card full-w text-align" fxLayoutAlign="center center"
                                *ngIf="prod.stock && prod.stock.count <= 0">
                                <span class="mat-caption boldest">{{"unavailable"|translate}}</span>
                            </div>

                            <!-- type menu Badge -->

                            <div *ngIf="prod.product_type==2 && (!prod.stock ||prod.stock && prod.stock.count > 0)"
                                fxLayoutAlign="center center" class="text-align menu  menu-badge-card">
                                <span class="mat-caption boldest">{{'Menu'|translate}}</span>
                            </div>
                            <!-- type option Badge -->
                            <!-- <div *ngIf="prod.product_type==1 && (!prod.stock ||prod.stock && prod.stock.count > 0)"
                                fxLayoutAlign="center center" class="text-align option  menu-badge-card">
                                <span class="mat-caption boldest">{{'Option'|translate}}</span>
                            </div> -->
                            <div *ngIf="ProductService.getNewProduct(prod.date) " fxLayoutAlign="center center"
                            class="text-align new  new-badge-card-list " [class.zindex-1]="prod.stock && prod.stock.count <= 0">
                            <span class="mat-caption boldest">{{'New'|translate}}</span>
                        </div>
                            <!-- Price period Badge -->
                            <div *ngIf="prod.id_price_period > 0"
                                class="layout-padd-1 rad-bord secondary clicked promo-badge-card">
                                <span class="mat-caption boldest">{{ProductService.getPricePeriodName(prod.id_price_period) | capitalize}}</span>
                            </div>

                            <div class="pos-img-cont rad-bord"
                                [class.out-of-stock-prod]="prod.stock && prod.stock.count <= 0" fxFlex="80"
                                [ngStyle]="{'background-image': 'url(' + ( prod.image.length > 0 ? prod.image[2] : default_prod) + ')'}">
                            </div>
                            <div fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="center center" style="padding:10px;"
                                fxFlex>
                                 <!-- Nom -->
                                 <div style="padding-bottom: 5px;" fxLayout="row" class="full-w">

                                    <div class="list-title elipis">{{prod.display_lang.name}}</div>
                                </div>

                                <span class="list-price"  *ngIf="prod.prices[0].price  > 0" ><span *ngIf="prodselected.prices[0].price <= prod.prices[0].price+price_supp">+</span> {{ getPrice(prod) |discountVipFilter:merchantClient$:prod
                                    |
                                    priceFilter}}</span>
                                <!-- <span class="list-price" *ngIf="prod.prices[0].price  > 0">+
                                    {{(prod.prices[0].price-prodselected.prices[0].price)
                                    |discountVipFilter:merchantClient$:prod
                                    | priceFilter}}</span> -->
                                <div fxFlex
                                    *ngIf="!prod.prices[0].price || prod.prices[0].price &&  prod.prices[0].price === 0">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




        </div>










        <!--  btn bottom -->
        <div fxLayout="row" *ngIf="buttonScroll" style="position:absolute; bottom:60px;right: 5px;">
            <div fxLayoutAlign="end start" fxFlex>
                <button mat-icon-button (click)="scroll()" style="z-index: 2;">
                    <mat-icon>arrow_drop_down_circle</mat-icon>
                </button>

            </div>
        </div>
        <div *ngIf="buttonScroll" id='buttonScroll'></div>







    </div>
    <div class="layout-padd positionBottom" fxLayoutAlign="center center" fxLayoutGap="10px" id="buttonB">
        <button mat-stroked-button fxFlex="80" (click)="setProductOriginal()">{{"formules.noThank" |
            translate}}</button>

    </div>

    <app-popup-loader [flagLoading]="loaderpop" [size]="30" [statusMessage]="statusMessage">
    </app-popup-loader>
</div>
